import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { LocalScheme } from '~auth/runtime'
import { Oauth2Scheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/",
    "home": "/dashboard",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "local",
  "autoFetchUser": false
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new LocalScheme($auth, {
  "endpoints": {
    "login": {
      "url": "https://api.drops.nyc/login",
      "method": "post",
      "propertyName": "token"
    },
    "logout": {
      "url": "https://api.drops.nyc/logout",
      "method": "post"
    },
    "user": {
      "url": "https://api.drops.nyc/updatedUser",
      "method": "get",
      "propertyName": ""
    }
  },
  "name": "local"
}))

  // spotify
  $auth.registerStrategy('spotify', new Oauth2Scheme($auth, {
  "endpoints": {
    "authorization": "https://accounts.spotify.com/authorize",
    "userInfo": "https://api.spotify.com/v1/me"
  },
  "scope": [
    "user-read-private",
    "user-read-email",
    "user-read-recently-played",
    "user-read-currently-playing",
    "streaming",
    "user-read-playback-state",
    "user-modify-playback-state"
  ],
  "access_token_endpoint": "https://drops.nyc/api/auth/spotify/swap",
  "responseType": "code",
  "token": {
    "type": "Bearer",
    "property": "access_token"
  },
  "redirectUri": "https://drops.nyc/api/auth/spotify/callback",
  "clientId": "c50e202c106e467ab34e307a9d30f80a",
  "name": "spotify"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
